// extracted by mini-css-extract-plugin
module.exports = {"paymentBackground":"PropertyPay_paymentBackground__32uIk","divBoxButton":"PropertyPay_divBoxButton__2pgUJ","paymentContent":"PropertyPay_paymentContent__3Jh1V"};